import React from "react";
import Texts, { currentLang, getMenuSampleImage, getQrDemoVideo } from "../../../utils/lang-utils";
import TypedText from '../../../areas/main/components/TypedText';
import urls from "../../../areas/main/assets/urls";

const Banner = () => {
  return (
    <section className="banner-one qr-menu" id="banner">
      <div className="container">
        
        <div className="row">
          <div className="col-xl-8 col-lg-8">
            <div className="banner-one__content">
                <h1 className="banner-one__text" dangerouslySetInnerHTML={{__html: Texts.QRMenu.IntroTitle}} />
                <h2 className="banner-one__title" >
                  {Texts.QRMenu.IntroTextPrefix}<br />
                  <strong><TypedText texts={Texts.QRMenu.IntroTextContent.split(",")}></TypedText></strong>
                  <br />
                  {Texts.QRMenu.IntroTextPostfix}
                </h2>
                <a href={urls.onboarding} className="banner-one__btn thm-btn ">
                  <span>{Texts.introCTA}</span>
                </a>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4">
              <div className="banner-one__moc qr-menu">
              {/* <img className="menu-moc" src={getMenuMockupImage()} /> */}

                <div className={`video ${currentLang}`}>
                
                    <img src={getMenuSampleImage()} style={{ display: 'block', visibility: 'visible'  }} ></img>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Banner;
